// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function getErrorCode(serviceError: any): string {
  return (
    (typeof serviceError.code === 'string' && serviceError.code) ||
    (typeof serviceError.message_code === 'string' &&
      serviceError.message_code) ||
    (typeof serviceError.error_type === 'string' && serviceError.error_type) ||
    (typeof serviceError.type === 'string' && serviceError.type) ||
    (typeof serviceError.error === 'string' && serviceError.error) ||
    (typeof serviceError.message === 'string' && serviceError.message) ||
    'could_not_get_error_code'
  );
}
